import React from 'react';
import { AccountIcon, RestaurantIcon, DeliveryIcon } from '../components/icons';

interface RoleSelectionScreenProps {
  onSelectFlow: (flow: 'client' | 'pro') => void;
}

const RoleSelectionScreen: React.FC<RoleSelectionScreenProps> = ({ onSelectFlow }) => {
  return (
    <div className="relative flex flex-col items-center justify-between h-[100dvh] bg-red-600 text-white p-8 overflow-hidden">

      {/* Decorative background elements (optional, to make it less empty) */}
      <div className="absolute top-0 right-0 -mr-20 -mt-20 w-64 h-64 rounded-full bg-red-500 opacity-50 blur-3xl mix-blend-screen pointer-events-none"></div>
      <div className="absolute bottom-0 left-0 -ml-20 -mb-20 w-80 h-80 rounded-full bg-red-700 opacity-50 blur-3xl mix-blend-multiply pointer-events-none"></div>

      {/* Top Section: Logo with animated dots (Pulse style like home) */}
      <div className="relative z-20 flex-1 flex flex-col items-center justify-center text-center mt-10">
        <div className="h-28 md:h-36 mb-6 animate-pulse drop-shadow-2xl">
          <img src="/logo.svg" alt="Yumii Logo" className="h-full w-auto object-contain drop-shadow-lg" />
        </div>
        <h2 className="text-3xl font-extrabold mb-2 drop-shadow-lg text-white tracking-tight">C'est parti !</h2>
        <p className="text-red-100 text-lg max-w-xs leading-relaxed font-medium">
          Comment souhaitez-vous utiliser Yumii aujourd'hui ?
        </p>
      </div>

      {/* Bottom Section: Buttons */}
      <div className="relative z-20 w-full max-w-sm pb-12 flex flex-col gap-4 animate-fade-in-up delay-100">
        <button
          onClick={() => onSelectFlow('client')}
          className="w-full py-5 bg-white text-red-600 text-xl font-bold rounded-2xl shadow-xl hover:bg-gray-50 hover:scale-[1.02] transform transition-all active:scale-95 flex items-center justify-center group"
        >
          <AccountIcon className="w-6 h-6 mr-3 text-red-600 group-hover:scale-110 transition-transform" />
          Espace Client
        </button>

        <button
          onClick={() => onSelectFlow('pro')}
          className="w-full py-5 bg-red-700 text-white text-xl font-bold rounded-2xl shadow-lg border border-red-500 hover:bg-red-800 hover:scale-[1.02] transform transition-all active:scale-95 flex items-center justify-center group"
        >
          <RestaurantIcon className="w-6 h-6 mr-3 text-red-200 group-hover:text-white transition-colors" />
          Espace Professionnel
        </button>

        {localStorage.getItem('yumii_admin_mode') === 'true' && (
          <button
            onClick={() => {
              // We keep the flag so ProAuthScreen knows to show the Admin Portal
              onSelectFlow('pro'); 
            }}
            className="w-full py-2 text-white/50 text-xs font-bold uppercase tracking-widest hover:text-white transition-colors mt-4"
          >
            Accès Super Admin
          </button>
        )}
      </div>

    </div>
  );
};

export default RoleSelectionScreen;